import { BaseUrlService } from './base-url.service';

export class UserService {
    static $inject: string[] = ['$http', 'BaseUrlService'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService,
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    getUser(email: any) {
        return this.$http.get(this.baseUrl + '/users/' + email);
    }

    updateLogo(user: any) {
        return this.$http.put(this.baseUrl + '/users/update-logo', user);
    }

    removeLogo(user: any) {
        return this.$http.put(this.baseUrl + '/users/remove-logo', user);
    }

    updateCodiceDestinatario(codiceDestinatario: any) {
        return this.$http.put(this.baseUrl + '/users/update-codice-destinatario', codiceDestinatario);
    }

    updatePersonalFiles(files: any) {
        return this.$http.put(this.baseUrl + '/users/update-personal-files', files);
    }

    renewSubscription(data: any) {
        return this.$http.put(this.baseUrl + '/users/request-renew-subscription', data);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/user.service.ts